import { Directive, HostListener } from '@angular/core';

@Directive({
    selector: '[appPreventSpaceAndLineBreak]'
})
export class PreventSpaceAndLineBreakDirective {
    @HostListener('keydown', ['$event'])
    onKeyDown(event: KeyboardEvent): void {

        const inputEl = event.target as HTMLInputElement | HTMLTextAreaElement;
        const value = inputEl.value;
        const caretPos = inputEl.selectionStart ?? 0;

        // Prevent line breaks
        if (event.key === 'Enter') {
            event.preventDefault();
        }

        // Prevent invalid spaces
        if (event.key === ' ') {
            if (caretPos === 0) event.preventDefault();  // space would be the first character
            if (value[caretPos - 1] === ' ') event.preventDefault(); //  character before is a space | caretPos -1 points to the position before the inserted character.
            if (value[caretPos] === ' ') event.preventDefault();  //  character after is a space  | caretPos points to the position after the inserted character.
        }
    }

}

